// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__Uauly","active":"Avatar_active__kP0SZ"};